module.exports = __webpack_public_path__ + "img/r-217.5b8a59bc.jpg";